<template>
 <v-card>
          <v-card-title> <h3 class="headline mb-0">Recycle Bin</h3>
          <v-btn text icon color="grey lighten-1" @click="refreshDeletedEndpoints"><v-icon>fas fa-sync</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchDeleted"
              append-icon="fal fa-search"
              placeholder="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>
    <v-data-table
    :headers="headers"
    :items="deletedEndpoints"
    :search="searchDeleted"
    v-model="selected"
    :options.sync="pagination"
    :loading="loading"
    show-select
    class="elevation-1">
        <template v-slot:item.hostAddress="{item}">
            <td><a :href="formatHostAddress(item)" target="_blank">{{ item.hostAddress }}</a></td>
        </template>
        <template v-slot:item.updatedDate="{item}">
            <td>{{ formatDateTime(item.updatedDate) }}</td>
        </template>
        <template v-slot:item.actions="{item}">
            <td class="actions">
                 <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        text
                        icon
                        @click="undelete(item)"
                        style="height: 0px; width: 0px; padding-right:2px;"
                        v-on="on"
                      >
                      <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash-restore</v-icon>
                    </v-btn>
                    </template>
                    <span>Restore</span>
                </v-tooltip>
            </td>
        </template>
    </v-data-table>
            <v-card-actions>
                <v-btn @click="undeleteSelected" :disabled="!selected.length">Restore Selected</v-btn>
          </v-card-actions>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            selected: [],
            searchDeleted: '',
            loading: false,
            deletedEndpoints: [],
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Host', align: 'left', sortable: true, value: 'hostAddress'},
                {text: 'Model', align: 'left', sortable: true, value: 'model'},
                {text: 'Firmware', align: 'left', sortable: true, value: 'firmware'},
                {text: 'Aliases', align: 'left', sortable: true, value: 'aliases'},
                {text: 'DN', align: 'left', sortable: true, value: 'dn'},
                {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            pagination : {'sortBy': ['updatedDate'], 'sortDesc': [true]}
        }
    },
    async created() {
        this.loading = true
        this.deletedEndpoints = await this.$store.dispatch('endpoints/getDeletedEndpoints')
        this.loading = false
    },
    methods: {
        formatHostAddress(endpoint) {
            if (!endpoint.hostAddress) {
                return ''
            }
            let protocol = endpoint.endpointProtocol
            if (protocol && (protocol !== 'Auto')) {
                protocol = protocol + '://'
            } else {
                protocol = 'https://'
            }
            return protocol + endpoint.hostAddress
        },
        getAliases(aliases) {
            if (!aliases) {
                return ''
            }
            let tokens = _.split(aliases, '/')
            return _.join(_.without(tokens, ''), ', ')
        },
        async undelete(endpoint) {
            await this.$store.dispatch('endpoints/unDeleteEndpoint', endpoint)
            this.$emit('endpointUnDeleted', endpoint.id)
            await this.refreshDeletedEndpoints()
        },
        async refreshDeletedEndpoints() {
            this.loading = true
            this.deletedEndpoints = await this.$store.dispatch('endpoints/getDeletedEndpoints')
            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).format('MM/DD/YYYY, h:mm:ss a')
        },
        async undeleteSelected() {
            await this.$store.dispatch('endpoints/unDeleteMultipleEndpoints', this.selected)
            this.$emit('endpointsUnDeleted', this.selected)
            this.selected = []
            await this.refreshDeletedEndpoints()
        }
    }
}
</script>
